// src/constants/brand.js
//
// homedepotshed.com and lowesheds.com are two separate storefronts that share
// ONE Supabase database with the ShedX platform, and both are owned by the same
// dealer (Edwin). `dealer_id` therefore cannot tell the two catalogs apart —
// the `brand` column on `sheds_inventory` is the discriminator.
//
// Every PUBLIC storefront query must be scoped to this brand. Without it this
// site would render lowesheds.com's catalog, because the two share a dealer row.
//
// The same string must be listed in ShedX's STANDALONE_STOREFRONT_BRANDS
// (shedx/src/services/shedService.js) so these rows stay hidden from the
// ShedX public site and its /dealer/:slug and /embed pages.
export const STOREFRONT_BRAND = 'Home Depot Sheds';

// Display name used in alt text and aria labels.
export const BRAND_NAME = 'Home Depot Sheds';

// Placeholder path for the site logo. The file does not exist yet — until it
// does, <BrandLogo> catches the 404 and renders the HD text wordmark instead.
//
// TO DROP IN THE REAL LOGO: save the artwork as
//   public/images/logo.png
// and it appears in the header and footer on the next dev-server reload /
// build. No code change required. Transparent PNG or SVG, roughly 4:1, sized
// for a 40px-tall header (so ~640x160 for a crisp @2x/@4x PNG). If you use
// .svg or .webp instead, change the extension on the line below.
//
// The logo renders on both the orange header bar and the dark footer bar, so
// use a single light/white-on-transparent mark unless you split this into two
// constants.
export const LOGO_SRC = '/images/logo.png';
